import React from 'react';
import { AssetTypeFilterDialog } from '@/components/investments/AssetTypeFilterDialogNew';
import { InstrumentDetailDrawer } from '@/components/instruments/InstrumentDetailDrawer';
import AssetDeletionDialogs from '@/components/assets/deletion/AssetDeletionDialogs';
import { AiImportDialog } from '@/components/assets/AiImportDialog';
import type { UnifiedAsset } from '@/hooks/useAssetsUnified';

type Blocked = { id: string; name: string; count: number; portfolios: string[] };
type Deletable = { id: string; name: string };

interface AssetsDialogsProps {
  // Filter + build portfolio
  showAssetTypeFilterDialog: boolean;
  setShowAssetTypeFilterDialog: (open: boolean) => void;
  collectedPositions: any[];
  onFilterContinue: (positions: any[]) => void;

  // Instrument drawer
  detailAsset: UnifiedAsset | null;
  showDetailDrawer: boolean;
  onCloseDetailDrawer: () => void;
  detailMode: 'view' | 'create' | 'edit' | 'position';
  onInstrumentCreated: () => void;

  // Deletion dialogs
  selectedAssetsCount: number;
  showDeleteConfirm: boolean;
  setShowDeleteConfirm: (open: boolean) => void;
  confirmDelete: () => void;
  showMixedDeleteConfirm: boolean;
  setShowMixedDeleteConfirm: (open: boolean) => void;
  mixedDeleteInfo: any;
  confirmDeleteManualOnly: () => void;
  showCascadeConfirm: boolean;
  setShowCascadeConfirm: (open: boolean) => void;
  cascadeBlocked: Blocked[];
  cascadeDeletable: Deletable[];
  cascadeShowAll: boolean;
  setCascadeShowAll: (val: boolean) => void;
  confirmCascadeDelete: () => void;

  // AI Import
  showAiImportDialog: boolean;
  setShowAiImportDialog: (open: boolean) => void;
  onAiImported: () => void;
}

export default function AssetsDialogs(props: AssetsDialogsProps) {
  const {
    showAssetTypeFilterDialog,
    setShowAssetTypeFilterDialog,
    collectedPositions,
    onFilterContinue,

    

    detailAsset,
    showDetailDrawer,
    onCloseDetailDrawer,
    detailMode,
    onInstrumentCreated,

    selectedAssetsCount,
    showDeleteConfirm,
    setShowDeleteConfirm,
    confirmDelete,
    showMixedDeleteConfirm,
    setShowMixedDeleteConfirm,
    mixedDeleteInfo,
    confirmDeleteManualOnly,
    showCascadeConfirm,
    setShowCascadeConfirm,
    cascadeBlocked,
    cascadeDeletable,
    cascadeShowAll,
    setCascadeShowAll,
    confirmCascadeDelete,

    showAiImportDialog,
    setShowAiImportDialog,
    onAiImported,
  } = props;

  return (
    <>
      {/* Build Portfolio Flow: Filter dialog first, then Add Positions dialog */}
      <AssetTypeFilterDialog
        open={showAssetTypeFilterDialog}
        onOpenChange={setShowAssetTypeFilterDialog}
        positions={collectedPositions}
        onContinue={onFilterContinue}
      />

      {/* Instrument Detail Drawer: used for both create and view */}
      <InstrumentDetailDrawer
        asset={detailAsset}
        open={showDetailDrawer}
        onClose={onCloseDetailDrawer}
        mode={detailMode}
        onCreated={onInstrumentCreated}
      />

      {/* Deletion dialogs */}
      <AssetDeletionDialogs
        selectedAssetsCount={selectedAssetsCount}
        showDeleteConfirm={showDeleteConfirm}
        setShowDeleteConfirm={setShowDeleteConfirm}
        confirmDelete={confirmDelete}
        showMixedDeleteConfirm={showMixedDeleteConfirm}
        setShowMixedDeleteConfirm={setShowMixedDeleteConfirm}
        mixedDeleteInfo={mixedDeleteInfo}
        confirmDeleteManualOnly={confirmDeleteManualOnly}
        showCascadeConfirm={showCascadeConfirm}
        setShowCascadeConfirm={setShowCascadeConfirm}
        cascadeBlocked={cascadeBlocked}
        cascadeDeletable={cascadeDeletable}
        cascadeShowAll={cascadeShowAll}
        setCascadeShowAll={setCascadeShowAll}
        confirmCascadeDelete={confirmCascadeDelete}
      />

      {/* AI Import Dialog */}
      <AiImportDialog
        open={showAiImportDialog}
        onOpenChange={setShowAiImportDialog}
        onImported={onAiImported}
      />
    </>
  );
}
